import createCustomSchema from "../fieldValidator/fieldValidator";
import * as Yup from "yup";

export const validationSchema = Yup.object({
  first_name: createCustomSchema("text", {
    message: "Enter First Name!",
    min: 3,
  }),
  middle_name: createCustomSchema("text", {
    message: "Enter middle Name!",
    min: 3,
  }),
  last_name: createCustomSchema("text", {
    message: "Enter last Name!",
    min: 3,
  }),
  personal_email: createCustomSchema("email", {
    message: "Enter Personal Email!",
  }),
  official_email: createCustomSchema("email", {
    message: "Enter Official Email!",
  }),
  alternate_number: createCustomSchema("phone", {
    message: "Enter Alternate Number!",
  }),
  number: createCustomSchema("phone", {
    message: "Enter Phone Number!",
  }),
  guardian_name: createCustomSchema("text", {
    message: "Enter Guardiuan Name!",
    min: 3,
  }),
  date_of_birth: createCustomSchema("date", {
    message: "Date of Birth is Required!",
  }),
  marital_status: createCustomSchema("dropdown", {
    message: "Select Marital Status!",
  }),
  married_date: createCustomSchema("date", {
    message: "Married Date is Required!",
  }),
  spouse_name: createCustomSchema("text", {
    message: "Select spouse Name!",
  }),
  nationality: createCustomSchema("dropdown", {
    message: "Select Nationality!",
  }),
  gender: createCustomSchema("dropdown", {
    message: "Select Gender !",
  }),
  aadhar: createCustomSchema("file", { message: "Select  Aadhar !" }),
  pan: createCustomSchema("file", { message: "Select Pan !" }),
  experience_letter: createCustomSchema("file", {
    message: "Select Experience Letter!",
  }),
  resignation_letter: createCustomSchema("file", {
    message: "Select Reileiving Letter!",
  }),
  photo: createCustomSchema("imageFile", { message: "Select Photo !" }),
});

export const validateAddress = Yup.object({
  current_address: createCustomSchema("address"),
  current_city: createCustomSchema("dropdown", {
    message: "Please Select a City !",
  }),
  current_state: createCustomSchema("dropdown", {
    message: "Please Select a State !",
  }),
  current_country: createCustomSchema("dropdown", {
    message: "Please Select a Country !",
  }),
  current_pincode: createCustomSchema("number", {
    message: "Maximun 6 digit Allowed!",
    max: 6,
  }),
  permanent_address: createCustomSchema("address"),
  permanent_city: createCustomSchema("dropdown", {
    message: "Please Select a City !",
  }),
  permanent_state: createCustomSchema("dropdown", {
    message: "Please Select a State !",
  }),
  permanent_country: createCustomSchema("dropdown", {
    message: "Please Select a Country !",
  }),
  permanent_pincode: createCustomSchema("number", {
    message: "Maximun 6 digit Allowed!",
    max: 6,
  }),
});

export const validateAccountDetail = Yup.object({
  account_number: createCustomSchema("number", {
    max: 16,
    min: 6,
    message: "Please Enter Account Number !",
  }),
  ifsc_code: createCustomSchema("alphanumeric", {
    max: 11,
    min: 11,
    message: "Please Enter IFSC Code !",
  }),
  account_holder_name: createCustomSchema("text", {
    min: 3,
    message: "Please Enter Account Holder Name !",
  }),
  branch_name: createCustomSchema("text", {
    min: 3,
    message: "Please Enter Branch Name !",
  }),
  uan_number: createCustomSchema("number", {
    max: 16,
    min: 16,
    message: "Please Enter UAN Number!",
  }),
  bank_name: createCustomSchema("text", {
    min: 3,
    message: "Please Enter Bank Name!",
  }),
  passbook_photo: createCustomSchema("imageFile", {
    message: "Please Upload Passbook Photo!",
  }),
});

export const validateQualification = Yup.object({
  qualification: createCustomSchema("text", {
    message: "Qualification is Required!",
    min: 3,
  }),
  university: createCustomSchema("text", {
    message: "University/Board is Required!",
    min: 3,
  }),
  passing_year: createCustomSchema("number", { max: 4 }),
  percentage: Yup.string()
      .matches(/^[0-9.]+$/, "Must be only digits or a decimal")
      .required("This field is required"),
  // document: createCustomSchema("number", {message : "Maximun 6 digit Allowed!" ,  max: 6 }),
});

export const validateEmploymentDetail = Yup.object({
  experience: createCustomSchema("decimalNumber", {
    message: "* Please enter experience!",
  }),
  joining_date: createCustomSchema("date", {
    message: "* Joining Date is Required!",
  }),
  department_id: createCustomSchema("dropdown", {
    message: "* Please select a department!",
  }),
  designation_id: createCustomSchema("dropdown", {
    message: "* Please select a designation!",
  }),
  salary: createCustomSchema("number", {
    message: "* Salary is Required!",
    max: 10,
  }),
  role_id: createCustomSchema("dropdown", {
    message: "* Role is Required!",
  }),
  selectedWorkLocation: createCustomSchema("number", {
    message: "* Working mode is Required!",
  }),
  selectedWorkShift: createCustomSchema("number", {
    message: "* Working shift is Required!",
  }),
  employment_id: createCustomSchema("alphanumeric", {
    message: "* Employment Id is Required!",
  }),
  probation_end_date: createCustomSchema("date", {
    message: "* Probation End Date is Required!",
  }),
  employment_type: createCustomSchema("dropdown", {
    message: "* Employment Type is Required!",
  }),
  employment_status: createCustomSchema("dropdown", {
    message: "* Employment Status is Required!",
  }),
  probation_status: createCustomSchema("dropdown", {
    message: "* Probation Status is Required!",
  }),
  performance_bonus: Yup.string().nullable().notRequired(),

});
